import React, { useEffect, useMemo, useState } from 'react';
import { Button, CircularProgress, Container, Typography } from '@mui/material';
import Settings from '../../store/settings';

const Login = () => {
  const [wasLoggedOut, setWasLoggedOut] = useState(
    () => {
      const loggedOut =
        new URLSearchParams(window.location.search).get('loggedOut') === 'true' ||
        localStorage.getItem('user_logged_out') === 'true';
      if (loggedOut) {
        localStorage.setItem('user_logged_out', 'true');
      }
      return loggedOut;
    },
  );
  const [showFallback, setShowFallback] = useState(wasLoggedOut);
  const returnUrl = useMemo(() => {
    const stored = localStorage.getItem('startLocation');
    return stored && stored.startsWith('/') && !stored.startsWith('//') ? stored : '/';
  }, []);
  const loginUrl = `${Settings.server}/auth/sso/login?returnUrl=${encodeURIComponent(returnUrl)}`;

  useEffect(() => {
    const url = new URL(window.location.href);
    if (url.searchParams.has('loggedOut')) {
      url.searchParams.delete('loggedOut');
      window.history.replaceState(window.history.state, '', url.toString());
    }
  }, []);

  useEffect(() => {
    if (wasLoggedOut) return;
    window.location.assign(loginUrl);
    const timer = window.setTimeout(() => setShowFallback(true), 2500);
    return () => window.clearTimeout(timer);
  }, [loginUrl, wasLoggedOut]);

  const startLogin = () => {
    localStorage.removeItem('user_logged_out');
    setWasLoggedOut(false);
    window.location.assign(loginUrl);
  };

  return (
    <Container
      maxWidth="sm"
      sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', textAlign: 'center' }}
    >
      <div>
        <CircularProgress />
        <Typography variant="h5" sx={{ mt: 3 }}>Вход в учет оборудования</Typography>
        <Typography color="text.secondary" sx={{ mt: 1 }}>
          {wasLoggedOut
            ? 'Вы вышли из учета оборудования и завершили единую SSO-сессию.'
            : 'Проверяем единую сессию и права на учет оборудования…'}
        </Typography>
        {showFallback && (
          <Button variant="contained" sx={{ mt: 3 }} onClick={startLogin}>
            Войти через единый центр авторизации
          </Button>
        )}
      </div>
    </Container>
  );
};

export default Login;
